import { render, staticRenderFns } from "./Software-Services.vue?vue&type=template&id=47724d3c&"
import script from "./Software-Services.vue?vue&type=script&lang=js&"
export * from "./Software-Services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports